import PageTabs from '@/components/page/PageTabs';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import ConfigurationSection from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/outputPanel/outputViewer/ConfigurationSection';
import HeaderSection from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/outputPanel/outputViewer/HeaderSection';
import ResponseSection from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/outputPanel/outputViewer/ResponseSection';
import PayloadSection from './outputLogViewer/PayloadSection';
import SummarySection from './outputLogViewer/SummarySection';
import useResponsive from '@/hooks/useResponsive.js';

// This component shows up in the output panel of the logs.

const OutputLogViewer = ({ output, search }) => {
  // This means an Axios request was made.
  const isAxiosRequest = output?.meta?.response && output?.meta?.response?.request;
  const configurationSectionResult = ConfigurationSection({ request: output?.meta?.request, dependencies: output?.meta?.dependencies });
  const tabKey = 'outputLogViewerTab';
  const defaultTab = '1';
  const activeTab = useArgSelector(query, tabKey) || defaultTab;
  const { tablet } = useResponsive();

  const childrenMap = {
    1: <SummarySection response={output} search={search} />
  };

  const items = [{ value: '1', label: 'Summary' }];

  if (output?.meta?.request?.arguments || output?.meta?.dependencies) {
    if (configurationSectionResult !== null) {
      childrenMap['2'] = configurationSectionResult;
      items.push({ value: '2', label: tablet ? 'Config' : 'Configuration' });
    }
  }

  if (isAxiosRequest) {
    childrenMap['3'] = <HeaderSection response={output?.meta?.response} />;
    items.push({ value: '3', label: 'Headers' });
  }

  if (output?.meta?.request && output?.meta?.request?.method?.toLowerCase() !== 'get') {
    childrenMap['4'] = <PayloadSection request={output?.meta?.request} />;
    items.push({ value: '4', label: 'Payload' });
  }

  if (output?.data) {
    childrenMap['5'] = <ResponseSection data={output?.data} />;
    items.push({ value: '5', label: 'Response' });
  }

  return (
    <div className="comp-output-viewer log">
      <PageTabs items={items} tabKey={tabKey} defaultTab={defaultTab} />
      <div className="content">{activeTab !== undefined && childrenMap[activeTab]}</div>
    </div>
  );
};

export default OutputLogViewer;
